import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {SystemApiService} from "@cv-invision/core";

@Injectable()
export class TenantAssociationService {
	constructor(
		private httpClient: HttpClient,
		private systemApiService: SystemApiService,
	) {}

	getIntegrations(): Observable<any> {
		return this.httpClient.get(
			`${this.systemApiService.api.orders}/utils/integrations`);
	}
}
